export const dateTimeConfig = {
  us: {
    dateShort: 'mm/dd/yyyy',
    dateYearShort: 'mm/dd/yy',
    dateTimeShort: 'mm/dd/yyyy h:MM tt',
    dateTime: 'mmm d',
    dateTimePartial: 'mmm d, h:MM tt',
    dateTimePartialLeading0: 'mmm dd, hh:MM tt',

    // remove with the old chart
    timeSpecifier: '%I:%M %p',
    hourSpecifier: '%I %p',

    // do not use with `dateFormat`
    amPm: true,
    dateTimeShortDateFns: 'MM/dd/yyyy hh:mm a',
    dateOnly: 'MM/dd/yyyy'
  },
  metric: {
    dateShort: 'dd.mm.yyyy',
    dateYearShort: 'dd.mm.yy',
    dateTimeShort: 'dd.mm.yyyy H:MM',
    dateTime: 'dd mmm',
    dateTimePartial: 'dd mmm, H:MM',
    dateTimePartialLeading0: 'dd mmm, HH:MM',

    // remove with the old chart
    timeSpecifier: '%H:%M',
    hourSpecifier: '%H',

    // do not use with `dateFormat`
    amPm: false,
    dateTimeShortDateFns: 'dd.MM.yyyy HH:mm',
    dateOnly: 'dd.MM.yyyy'
  }
};
